
import { Switch, Route, NavLink, useRouteMatch } from "react-router-dom"

import DistPromptsList from "./DistPromptsList"
import EditDistPrompt from "./EditDistPrompt"
import EditIntervention from "./EditIntervention"
import EditPrompt from "./EditPrompt"
import InterventionsList from "./InterventionsList"
import InterventionsMenu from "./InterventionsMenu"
import InterventionsMenuCategory from "./InterventionsMenuCategory"

import { PATHS } from "../urls"

const InterventionsEditor = () => {
    const { url } = useRouteMatch()

    return (
        <div className="interventions-editor">
            <nav id="tab-selector">
                <NavLink
                    to={`${url}`}
                    className="tab-button"
                    activeClassName="active-tab"
                >
                    Interventions List
                </NavLink>
                <NavLink
                    to={`${url}/distinguishing-prompts`}
                    className="tab-button"
                    activeClassName="active-tab"
                >
                    Distinguishing Prompts
                </NavLink>
                <NavLink
                    to={`${url}/menu`}
                    className="tab-button"
                    activeClassName="active-tab"
                >
                    Interventions Menu
                </NavLink>
            </nav>
            <Switch>
                {/* see urls.js to see actual paths, and how you need to order the routes */}
                <Route path={PATHS.DIST_PROMPT_EDIT} component={EditDistPrompt} />
                <Route path={PATHS.DIST_PROMPTS_LIST} component={DistPromptsList} />
                <Route path={PATHS.INTV_MENU_CAT_EDIT} component={InterventionsMenuCategory} />
                <Route path={PATHS.INTV_MENUS_LIST} component={InterventionsMenu} />
                <Route path={PATHS.PROMPT_EDIT} component={EditPrompt} />
                <Route path={PATHS.INTV_EDIT} component={EditIntervention} />
                <Route path={PATHS.INTVS_LIST} component={InterventionsList} />
                {/* default route */}
                <Route>
                    <div>click on a tab above</div>
                </Route>
            </Switch>
        </div>
    )
}

export default InterventionsEditor